<script setup>
import { ref, defineProps, defineModel, defineEmits } from "vue";
import Button from "primevue/button";
import Textarea from "primevue/textarea";
import RutasSelect from "./RutasSelect.vue";
import RutasPoint from "./RutasPoint.vue";

const data = defineModel({ default: [] });
const pointType = defineModel('pointType', { default: 'route' });
const props = defineProps({
  latLng: {
    type: Object
  },
});
const emit = defineEmits(['refreshPoint']);
const activePoint = ref(null);

const refreshPoint = (e) => {
  emit('refreshPoint', e);
};

const addPoint = (type) => {
  console.log("addPoint", activePoint.value);
  pointType.value = type;

  const newPoint = {
    type,
    notes: ''
  };
  
  if ([ 'home', 'market' ].includes(type)) {
    
    newPoint.vehicleType = 'car';
    newPoint.security = 'normal';

    if (type === 'home') {
      newPoint.houses = '1';
    } else if (type === 'market') {
      newPoint.markets = '1';
    }
  } 

  data.value = [
    ...data.value,
    newPoint
  ]
  activePoint.value = data.value.length;
};

const savePoint = () => {
  console.log("savePoint", activePoint.value, props.latLng);

  data.value = data.value.map((point, index) =>{
    if (index === activePoint.value) {
      return {
        ...point,
        latlng: props.latLng
      }
    }
    return point;
  });
  pointType.value = 'route';
  refreshPoint();
};

const deletePoint = () => {
  if (activePoint.value === null) {
    refreshPoint();
    return
  }; 
  data.value = data.value.filter((point, index) => index !== activePoint.value);
  activePoint.value = null;
  pointType.value = 'route';
  refreshPoint();
};

const editPoint = (index) => {
  activePoint.value = index;
  pointType.value = data.value[index].type;
  refreshPoint({
    ...data.value[index]
  });
};

</script>

<template>
  <div>
    <div v-if="pointType === 'route'">
      <h3 class="mb-3 mt-2">Información de la ruta</h3>
      <div class="flex flex-wrap gap-2">

        <Button
          class="noprint"
          label="Agregar Zona Poblada"
          icon="pi pi-home"
          severity="secondary"
          size="small"
          outlined
          @click="addPoint('home')"
        />
  
        <Button
          class="noprint"
          label="Agregar Negocios"
          icon="pi pi-shopping-cart"
          severity="secondary"
          size="small"
          outlined
          @click="addPoint('market')"
        />
      </div>

      


      <div v-if="data.length > 0" class="mt-4">
        
       <div v-for="(point, index) in data" :key="index" class="point-detail" @click="editPoint(index)">
          <RutasPoint :doc="point" :index="index" @refreshPoint="refreshPoint" />
       </div>
      </div>

    </div>
    <div v-else>

      <div v-if="pointType === 'home'">
        <h2>Zona Poblada</h2>
        <div class="point" v-if="!props.latLng">
          Seleccione el punto en el mapa.
        </div>
        <small v-else>
          Punto seleccionado: {{ props.latLng.lat }}, {{ props.latLng.lng }}
        </small>
      </div>
      
      <div class="form" v-if="data[activePoint]">
        <small>Agrega la siguiente información adicional:</small>
        <div v-if="data[activePoint].houses" class="p-fluid">
          <RutasSelect listName="houses" v-model="data[activePoint].houses" />
        </div>
        <div v-if="data[activePoint].markets" class="p-fluid">
          <RutasSelect listName="markets" v-model="data[activePoint].markets" />
        </div>
        <div v-if="data[activePoint].vehicleType" class="p-fluid">
          <RutasSelect listName="vehicleType" v-model="data[activePoint].vehicleType" />
        </div>
        <div v-if="data[activePoint].security" class="p-fluid">
          <RutasSelect listName="security" v-model="data[activePoint].security" />
        </div>
        <div>
          <h3 for="">Notas</h3>
          <div class="p-fluid">

            <Textarea id="notes" v-model="data[activePoint].notes" rows="3" />
          </div>
        </div>
  
        <div class="flex flex-row gap-2 mt-3">
          <div>

            <Button
              class="p-button-success"
              label="Guardar"
              icon="pi pi-check"
              @click="savePoint('route')"
              v-if="props.latLng"
            />
          </div>
          <div>

            <Button
            severity="danger"
              label="Eliminar"
              icon="pi pi-trash"
              @click="deletePoint('route')"
            />
          </div>
  
  
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.point {
  margin: 5px 0;
  color: red;
}
/* h3 {
  font-weight: bold;
  margin: 10px 0;
} */
h3 {
  margin: 0;
  font-weight: normal;
  text-align: left;
  margin-bottom: 5px;
  color: var(--accent);
}

</style>